import { downloadBlob } from './downloadBlob';
export async function downloadFile(url, filename) {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to download file: ${response.status} ${response.statusText}`);
    }
    const blob = new Blob([await response.blob()], { type: 'application/octet-stream' });
    await downloadBlob(blob, filename);
}
